import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { ClientSystemLink } from 'app/organization/model/client-system-link';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { RouterLinkActive } from '@angular/router';
import { User } from 'app/account/model/user';
import { UserService } from '@customer-apps/user/user.service';
import { ApiImageUrlPipe } from '@customer-apps/api-image/api-image-url.pipe';
import { ProfileImageComponent } from '@styleguide/profile/profile-image/profile-image.component';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';
import { AddApiHostPipe } from '@customer-apps/router/add-api-host.pipe';

@Component({
  selector: 'kgr-client-system-link',
  imports: [AsyncPipe, RouterLinkActive, JsonPipe, ApiImageUrlPipe, ProfileImageComponent, SvgIconDirective, AddApiHostPipe],
  templateUrl: './client-system-link.component.html',
  styleUrl: './client-system-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientSystemLinkComponent {
  @Input({ required: true }) clientSystemLink: ClientSystemLink;

  open = signal<boolean>(false);

  constructor(public userService: UserService<User>) {}

  toggleDropdown() {
    this.open.update((open) => !open);
  }
}
